module.exports = __webpack_public_path__ + "d58908d198123d3c50c18638f58abb26.svg";